import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Spin, Popover, Icon, Col, Row, Form, Input, Button, Modal, Radio } from 'antd';
import { validation_rules } from '../../../../shared/validation_rules';
import {
    getDriver,
    createDriver,
    updateDriverPassword,
    getCalendarUser,
    createCalendarUser,
    updateCalendarUserPassword,
    updateCalendarAccess,
    resetTransportUser
} from '../redux/actions/transport_user.actions';
import PropTypes from 'prop-types';

const FormItem = Form.Item;
const Password = Input.Password;

const USER_TYPE = {
    DRIVER: 'driver',
    CALENDAR: 'calendar'
}

const MODAL_TYPE = {
    CREATE_DRIVER: 'Create driver',
    UPDATE_DRIVER_PASSWORD: 'Update driver password',
    CREATE_CALENDAR_USER: 'Create calendar user',
    UPDATE_CALENDAR_USER_PASSWORD: 'Update calendar user password'
}

const hintValidation = (
    <ul>
        <li>8-character minimum length</li>
        <li>Contains at least 1 number</li>
        <li>Contains at least 1 lowercase letter</li>
        <li>Contains at least 1 uppercase letter</li>
        <li>Contains at least 1 special character from the following set
            <br/>or a non-leading, non-trailing space character.
            <br/>^ $ * . [ ] { } ( ) ? - " ! @ # % & / \ , &gt; &lt; ' : ; | _ ~ ` + =
        </li>
    </ul>);

const radioStyles = {
    display: 'flex',
    flexDirection: 'column',
    gap: 8,
    margin: "8px 0"
};

const radioOptions = [{label: 'Read Only', value: false}, {label: 'Read + Write', value: true}];

class ProfileTransport extends Component {
    state = {
        [USER_TYPE.DRIVER]: {
            password: '',
            validationError: '',
        },
        [USER_TYPE.CALENDAR]: {
            password: '',
            validationError: '',
        },
        isCalendarAdmin: false,
        modalType: null,
    };

    componentDidMount() {        
        this.props.dispatch(getDriver(this.props.email));
        this.props.dispatch(getCalendarUser(this.props.email));
    }

    componentWillUnmount() {
        this.props.dispatch(resetTransportUser());
    }

    getInputValueHandler = (event, type) => {
        const value = event.target.value;

        this.setState({
            [type]: {
                password: value,
                validationError: validation_rules.create_cognito_password(value),
            }
        });
    };

    updateAccess = (event) => {
        this.props.dispatch(updateCalendarAccess({
            email: this.props.email,
            userId: this.props.id,
            isAdmin: event.target.value
        }));
    }

    setAccess = (event) => {
        this.setState({isCalendarAdmin:event.target.value});
    }

    openModal = (type) => {
        this.setState({modalType: type});
    }

    closeModal = () => {
        this.setState({modalType: null});
    }

    submit = () => {
        switch (this.state.modalType) {
            case MODAL_TYPE.CREATE_DRIVER: {
                this.props.dispatch(createDriver({
                    email: this.props.email,
                    password: this.state[USER_TYPE.DRIVER].password,
                    userId: this.props.id
                }));
                break;
            }
            case MODAL_TYPE.UPDATE_DRIVER_PASSWORD: {
                this.props.dispatch(updateDriverPassword({
                    email: this.props.email,
                    password: this.state[USER_TYPE.DRIVER].password
                }));
                break;
            }
            case MODAL_TYPE.CREATE_CALENDAR_USER: {
                this.props.dispatch(createCalendarUser({
                    email: this.props.email,
                    password: this.state[USER_TYPE.CALENDAR].password,
                    userId: this.props.id,
                    isAdmin: this.state.isCalendarAdmin
                }));
                break;
            }
            case MODAL_TYPE.UPDATE_CALENDAR_USER_PASSWORD: {
                this.props.dispatch(updateCalendarUserPassword({
                    email: this.props.email,
                    password: this.state[USER_TYPE.CALENDAR].password
                }));
                break;
            }
            default:
                break;
        };
        this.closeModal();
    }

    render() {
        const { id, email, driver, calendarUser } = this.props;
        const driverAction = driver.data ? MODAL_TYPE.UPDATE_DRIVER_PASSWORD : MODAL_TYPE.CREATE_DRIVER;
        const calendarAction = calendarUser.data ? MODAL_TYPE.UPDATE_CALENDAR_USER_PASSWORD : MODAL_TYPE.CREATE_CALENDAR_USER;

        return (
            <>
                <Row>
                    <Col span={11}>
                        <Spin spinning={driver.isLoading} tip="Loading...">
                            <h3 style={{ marginBottom: 20 }}>Inspection details</h3>
                            <div className="user_profile_top_label">Driver ID</div>
                            <div className="user_profile_value">{id}</div>
                            <div className="user_profile_label">Inspection username</div>
                            <div className="user_profile_value">{email}</div>
                            <div className="user_profile_label">Inspection password</div>
                            <FormItem>
                                <div className='cognito-password'>
                                    <Password
                                        name="password"
                                        onChange={(e) => this.getInputValueHandler(e, USER_TYPE.DRIVER)}
                                    />
                                    <Popover content={hintValidation} trigger="click">
                                        <Icon type="question-circle" theme="twoTone" className='cognito-password__hint' />
                                    </Popover>
                                    <span className="createUserValidationError cognito-password__validation-message">
                                        {this.state[USER_TYPE.DRIVER].validationError}
                                    </span>
                                </div>
                            </FormItem>    
                            <Button
                                type="primary"
                                style={{ marginTop: 20 }}
                                disabled={!!this.state[USER_TYPE.DRIVER].validationError || !this.state[USER_TYPE.DRIVER].password}
                                onClick={() => this.openModal(driverAction)}
                                >
                                    {driverAction} 
                            </Button>
                        </Spin>
                    </Col>
                    <Col span={11} offset={2}>
                        <Spin spinning={calendarUser.isLoading} tip="Loading...">
                            <div className='divider'>
                                <h3 style={{ marginBottom: 20 }}>Calendar details</h3>
                                <div className="user_profile_top_label">Calendar access</div>
                                <FormItem>
                                    {calendarUser.data ?
                                        <Radio.Group
                                            style={radioStyles}
                                            value={!!calendarUser.data?.isAdmin}
                                            options={radioOptions}
                                            onChange={this.updateAccess}
                                        />
                                        :
                                        <Radio.Group
                                            style={radioStyles}
                                            value={this.state.isCalendarAdmin}
                                            options={radioOptions}
                                            onChange={this.setAccess}
                                        />
                                    }
                                </FormItem>
                                <div className="user_profile_label">Calendar username</div>
                                <div className="user_profile_value">{email}</div>
                                <div className="user_profile_label">Calendar password</div>
                                <FormItem>
                                    <div className='cognito-password'>
                                        <Password
                                            name="password"
                                            onChange={(e) => this.getInputValueHandler(e, USER_TYPE.CALENDAR)}
                                        />
                                        <Popover content={hintValidation} trigger="click">
                                            <Icon type="question-circle" theme="twoTone" className='cognito-password__hint' />
                                        </Popover>
                                        <span className="createUserValidationError cognito-password__validation-message">
                                            {this.state[USER_TYPE.CALENDAR].validationError}
                                        </span>
                                    </div>
                                </FormItem>    
                                <Button
                                    type="primary"
                                    style={{ marginTop: 20 }}
                                    disabled={!!this.state[USER_TYPE.CALENDAR].validationError || !this.state[USER_TYPE.CALENDAR].password}
                                    onClick={() => this.openModal(calendarAction)}
                                    >
                                        {calendarAction} 
                                </Button>
                            </div>
                        </Spin>
                    </Col>
                </Row>

                <Modal
                    visible={!!this.state.modalType}
                    onCancel={this.closeModal}
                    footer={null}
                    title={this.state.modalType}
                >
                    <p style={{ marginBottom: 20 }}>The password will not be visible on the page once submitted.</p>
                    <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                        <Button
                            type="primary"
                            style={{ marginLeft: 10 }}
                            onClick={this.submit}
                        >
                            {this.state.modalType}
                        </Button>
                    </div>
                </Modal>
            </>
        );
    }
}

const mapStateToProps = (state) => {
    const { profile } = state.UserManagement.User_profile.User_profile_table;
    const { driver, calendarUser } = state.UserManagement.Transport_user;

    const id = profile?._id;
    const email = profile?.login;

    return {
        id, email, driver, calendarUser
    };
};

ProfileTransport.propTypes = {
    dispatch: PropTypes.func,
    id: PropTypes.string,
    email: PropTypes.string,
    driver: PropTypes.shape({ isLoading: PropTypes.bool, data: PropTypes.object }),
    calendarUser: PropTypes.shape({ isLoading: PropTypes.bool, data: PropTypes.object })
};

export default connect(mapStateToProps, null)(ProfileTransport);



// WEBPACK FOOTER //
// ./src/modules/UserManagement/User_profile/components/ProfileTransport.js